import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import LoadingView from "../views/LoadingView";
import AdvertisementBillingStore from "../../stores/AdvertisementBillingStore";
import AdvertisingBillingView from "../views/AdvertisingBillingView";


export default class AdvertisingBillingContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "advertisementBillingStore": AdvertisementBillingStore.getState()
        }
    }

    componentDidMount() {
        this.advertisementBillingStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_BILLING_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(
            UIInteractionEvents.ADVERTISEMENT_BILLING_MOUNTED, {
                selectedYear: this.state.advertisementBillingStore.selectedYear,
                selectedMonth: this.state.advertisementBillingStore.selectedMonth
            });
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.advertisementBillingStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_BILLING_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementBillingStore": AdvertisementBillingStore.getState()
        });
    };

    render() {
        if (this.state.advertisementBillingStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.advertisementBillingStore.loadingState === LoadingStates.LOADING
        ) {
            return (
                <LoadingView titleText="Loading Billing"/>
            );
        }

        return (
            <AdvertisingBillingView
                selectedMonth={this.state.advertisementBillingStore.selectedMonth}
                selectedYear={this.state.advertisementBillingStore.selectedYear}
                paidReservations={this.state.advertisementBillingStore.paidReservations}
            />
        );
    }


}